<template>
  <div class="content">
    <div class="top">
      <div>累计统计：</div>
      <div style="display: flex;width: 50%;margin: 0 auto;justify-content: space-between;">
        <div class="flex" style="background-color: #0ccf93;" @click="toList(1)">
          <span>{{negativeCount}}</span>
          <span>核酸阴性</span>
        </div>
        <div class="flex" style="background-color: #e32932;" @click="toList(2)">
          <span>{{positiveCount}}</span>
          <span>核酸阳性</span>
        </div>
        <div class="flex" style="background-color: #bebebe;" @click="toList(3)">
          <span>{{noReportCount}}</span>
          <span>无核酸报告</span>
        </div>
      </div>
    </div>
    <div class="main">
      <div>数据统计：</div>
      <div ref="chart" style="width: 100%;height: 70vh;"></div>
    </div>
  </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
  export default {
    data() {
      return {
        projectId: '',
        negativeCount: '',
        noReportCount: '',
        positiveCount: '',
        chartData: []
      }
    },
    mounted(){
      this.projectId = util.session.get('groupId')
      this.getData()
    },
    methods: {
      getData(){
        myHttp.findProjectPersonNucleicAcidStatistics({
          projectId: this.projectId
        }).then(resp => {
          if(resp.data.code == '200'){
            console.log(resp);
            this.negativeCount = resp.data.data.projectPersonNucleicAcidStatistics.negativeCount || 0
            this.noReportCount = resp.data.data.projectPersonNucleicAcidStatistics.noReportCount || 0
            this.positiveCount = resp.data.data.projectPersonNucleicAcidStatistics.positiveCount || 0
            this.chartData[0] = this.negativeCount
            this.chartData[1] = this.positiveCount
            this.chartData[2] = this.noReportCount
            this.initChart()
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },
      initChart(){
        let myChart = this.$echarts.init(this.$refs.chart)
        myChart.setOption({
          xAxis: {
            type: 'category',
            data: ['核酸阴性', '核酸阳性', '无核酸报告'],
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              type: 'bar',
              data: this.chartData,
              barWidth: 40,
              label: {
                show: true,
                position: 'top'
              },
              itemStyle:{
                //每个柱子颜色不同
                color:function(data){
                    let colorList=['#0ccf93', '#e32932', '#bebebe'];
                    return colorList[data.dataIndex];
                  }
              }
            }
          ]
        })
      },
      toList(index){
        this.$router.push({
          path: '/nucleateCount',
          query: {
            flag: index
          }
        })
      }
    },
  }
</script>

<style scoped>
.content{
  background-color: #fff;
  padding: 1vh 4vw;
}
.top{
  display: flex;
  margin-top: 2vh;
  align-items: center;
}
.flex{
  width: 9vw;
  height: 8vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 7px;
  cursor: pointer;
  color: #fff;
}
.main{
  margin-top: 2vh;
  padding-top: 3vh;
  border-top: 1px solid #ccc;
  text-align: left;
}
</style>